<template>
  <div class="system-section">
    <span class="type-title">
      系统
      <i>
        (共
        <em> {{sectionData.length}} </em> 条记录)
      </i>
      <look-more v-if="hideContent && sectionData.length>max" type="system" />
    </span>
    <div class="data-view" v-if="sectionData.length>0">
      <a
        v-for="(i,n) in (hideContent ? sectionData.slice(0,max):sectionData)"
        :key="n"
        class="result-item"
        :href="i.url"
        target="_blank"
        v-high-light="{key:$route.params.key,content:i.title}"
      >{{i.title}}</a>
    </div>
  </div>
</template>
<script>
import lookMore from "./look-more";
export default {
  name: "system-section",
  components: { lookMore },
  props: {
    sectionData: Array,
    hideContent: {
      type: Boolean,
      default: true
    },
    max: {
      type: Number,
      default: 6
    }
  }
};
</script>
<style lang="scss" scoped>
.system-section {
  .data-view {
    display: grid;
    grid-column-gap: 80px;
    grid-template-columns: auto auto auto auto auto 1fr;
  }
  .result-item {
    display: inline-block;

    font-size: 14px;
  }
}
</style>
